// Static brand constants. Runtime values (WhatsApp number, Instagram handle) are
// served from /api/site-config and consumed via `useSiteConfig`.
export const WHATSAPP_NUMBER = "919355012999";
export const WHATSAPP_DISPLAY = "+91 93550 12999";

// Backwards-compatible helper. Accepts either (message) or (number, message).
export const whatsappLink = (a = "Hi Vyagram, I'd like to plan a stay.", b) => {
  const looksLikeNumber = typeof a === "string" && /^\+?\d[\d\s-]{6,}$/.test(a);
  const number = (looksLikeNumber ? a : WHATSAPP_NUMBER).replace(/[^\d]/g, "");
  const message = b !== undefined ? b : (looksLikeNumber ? "Hi Vyagram, I'd like to plan a stay." : a);
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

// Social validation anchors — retained as last-resort fallbacks.
const SUPERHOST_SINCE = new Date("2022-11-01T00:00:00Z");
export const socialSuperhostQuarters = () => {
  const now = new Date();
  const monthsDiff =
    (now.getFullYear() - SUPERHOST_SINCE.getUTCFullYear()) * 12 +
    (now.getUTCMonth() - SUPERHOST_SINCE.getUTCMonth());
  return Math.max(1, Math.floor(monthsDiff / 3));
};
export const SOCIAL_STATS = {
  superhostSince: SUPERHOST_SINCE,
  get superhostQuarters() { return socialSuperhostQuarters(); },
  totalStaysHosted: 2580,
  fiveStarReviews: 415,
};

// Common country dial codes, India-first.
export const COUNTRY_CODES = [
  { code: "IN", dial: "+91", name: "India", flag: "🇮🇳" },
  { code: "US", dial: "+1", name: "United States", flag: "🇺🇸" },
  { code: "GB", dial: "+44", name: "United Kingdom", flag: "🇬🇧" },
  { code: "AE", dial: "+971", name: "UAE", flag: "🇦🇪" },
  { code: "SG", dial: "+65", name: "Singapore", flag: "🇸🇬" },
  { code: "AU", dial: "+61", name: "Australia", flag: "🇦🇺" },
  { code: "CA", dial: "+1", name: "Canada", flag: "🇨🇦" },
  { code: "DE", dial: "+49", name: "Germany", flag: "🇩🇪" },
  { code: "FR", dial: "+33", name: "France", flag: "🇫🇷" },
  { code: "JP", dial: "+81", name: "Japan", flag: "🇯🇵" },
  { code: "SA", dial: "+966", name: "Saudi Arabia", flag: "🇸🇦" },
  { code: "NP", dial: "+977", name: "Nepal", flag: "🇳🇵" },
  { code: "LK", dial: "+94", name: "Sri Lanka", flag: "🇱🇰" },
  { code: "BD", dial: "+880", name: "Bangladesh", flag: "🇧🇩" },
  { code: "TH", dial: "+66", name: "Thailand", flag: "🇹🇭" },
  { code: "MY", dial: "+60", name: "Malaysia", flag: "🇲🇾" },
  { code: "ID", dial: "+62", name: "Indonesia", flag: "🇮🇩" },
  { code: "NL", dial: "+31", name: "Netherlands", flag: "🇳🇱" },
  { code: "IT", dial: "+39", name: "Italy", flag: "🇮🇹" },
  { code: "ES", dial: "+34", name: "Spain", flag: "🇪🇸" },
];

export const defaultCountryFromLocale = () => COUNTRY_CODES[0];
